<template>
  <div class="pb-2">
    <p>
      Please enter your contact information, review the type of service you are scheduling, then
      enter the ZIP Code or select the City/Town of the area where you would like to schedule your
      appointment. When making multiple appointments, please use the same phone number.
    </p>
    <LoadingBusy :loading="loading" :isAuthenticating="false" text="Loading, please wait...">
    </LoadingBusy>
    <v-form v-model="valid">
      <v-row justify="space-between">
        <v-col cols="12" md="6">
          <v-card>
            <v-card-title class="page-heading"> Appointment Information </v-card-title>
            <v-card-text class="centerContainer text-body-1">
              <v-row>
                <v-col class="font-weight-bold">SC Drivers License Number: </v-col>
                <v-col>{{ dLNumber }}</v-col>
              </v-row>
              <v-row>
                <v-col class="font-weight-bold">First Name: </v-col>
                <v-col>{{ firstName }}</v-col>
              </v-row>
              <v-row>
                <v-col class="font-weight-bold">Last Name: </v-col>
                <v-col>{{ lastName }}</v-col>
              </v-row>
              <v-row>
                <v-col class="font-weight-bold">Date of Birth: </v-col>
                <v-col>{{ dateOfBirth }}</v-col>
              </v-row>
              <v-row>
                <v-text-field
                  clearable
                  v-model="emailField"
                  label="Email"
                  prepend-inner-icon="mdi-email"
                  filled
                  dense
                  :rules="[isValidEmail]"
                ></v-text-field>
              </v-row>
              <v-row>
                <v-text-field
                  clearable
                  v-model="phoneField"
                  label="Phone"
                  prepend-inner-icon="mdi-phone"
                  filled
                  dense
                  maxlength="14"
                  :rules="[isValidPhone]"
                  @keypress="isNumber($event)"
                  @input="formatPhoneNumber"
                ></v-text-field>
              </v-row>
              <v-row>
                <div>
                  <v-checkbox
                    v-model="textMsgCheck"
                    class="mt-n4"
                    label="I prefer to receive notifications via text message
                    (requires mobile number)"
                  ></v-checkbox>
                </div>
                <div>
                  <v-checkbox
                    class="mt-n4"
                    style="display: none"
                    label="ADA accomodation required"
                  ></v-checkbox>
                </div>
                <div>
                STANDARD DATA FEES AND TEXT MESSAGING RATES MAY APPLY BASED ON YOUR PLAN WITH YOUR
                MOBILE PHONE CARRIER. As mobile access and text message delivery is subject to your
                mobile carrier network availability, such access and delivery is not guaranteed.
                </div>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
        <v-col cols="12" md="6">
          <v-card>
            <v-card-title class="page-heading"> Service Type: {{ testTypeText }} </v-card-title>
            <v-card-text class="centerContainer">
              <v-row>
                1. If you would like to filter your results to a specific day of the week, select it
                below. Otherwise, leave it set to "Any Day"
              </v-row>
              <v-row>
                <v-select
                  label="Day of Week"
                  prepend-inner-icon="mdi-calendar-range"
                  filled
                  :items="daysOfWeek"
                  item-text="Text"
                  item-value="Code"
                  v-model="preferredDay"
                  dense
                ></v-select>
              </v-row>
              <v-row>
                2. Enter a ZIP Code or city of where you wish to make your appointment and click
                "Next",
              </v-row>
              <v-row>
                <v-col>
                  <v-text-field
                    clearable
                    label="Zip Code"
                    prepend-inner-icon="mdi-map-marker"
                    filled
                    v-model="zipCode"
                    mask="#####"
                    placeholder="#####"
                    maxlength="5"
                    inputmode="numeric"
                    :rules="zipRules"
                    @keypress="isNumber"
                    dense
                  ></v-text-field>
                </v-col>
                <v-col
                  ><v-select
                    clearable
                    label="City/Town"
                    prepend-inner-icon="mdi-city"
                    filled
                    :items="cities"
                    item-text="Name"
                    item-value="Name"
                    v-model="cityName"
                    :rules="cityRules"
                    dense
                  ></v-select
                ></v-col>
              </v-row>
              <v-row class="font-weight-bold"> ZIP code or City/Town required. </v-row>
            </v-card-text>
          </v-card>
          <div class="text-center btn-container">
            <v-layout class="pt-5" row wrap>
              <v-flex class="sm6 pa-1">
                <v-btn class="ma-2" color="primary" @click="previousClick()"
                  ><v-icon>mdi-arrow-left</v-icon>
                  PREVIOUS
                </v-btn>
              </v-flex>
              <v-flex class="sm6 pa-1">
                <v-btn
                  class="ma-2"
                  color="primary"
                  :disabled="!valid"
                  @click="getAvailableLocation()"
                >
                  NEXT
                  <v-icon>mdi-arrow-right</v-icon>
                </v-btn>
              </v-flex>
            </v-layout>
          </div>
        </v-col>
      </v-row>
      <div>
        <v-alert
          class="ma-2"
          type="error"
          :value="isError"
          dense
          outlined
          dismissible
          transition="scale-transition"
        >
          {{ errorMessage }}
        </v-alert>
      </div>
    </v-form>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import scApi from '../api/scApi';
import LoadingBusy from '../components/LoadingBusy.vue';

export default {
  name: 'CustomerDetailsPage',
  components: {
    LoadingBusy,
  },
  data() {
    return {
      valid: false,
      daysOfWeek: [
        { Code: 0, Text: 'Any Day' },
        { Code: 1, Text: 'Monday' },
        { Code: 2, Text: 'Tuesday' },
        { Code: 3, Text: 'Wednesday' },
        { Code: 4, Text: 'Thursday' },
        { Code: 5, Text: 'Friday' },
      ],
      cityName: '',
      zipCode: '',
      preferredDay: 0,
      loading: false,
      emailField: '',
      phoneField: '',
      textMsgCheck: '',
      isError: false,
      errorMessage: '',
      rules: {
        required: (v) => !!v || this.Validation(''),
        validZip: (v) => (v && this.ValidZip(v))
          || this.Validation('Invalid Zipcode'),
        validCity: (v) => !!v || !!this.zip
          || this.Validation('City or Valid Zipcode is Required'),
      },
    };
  },
  methods: {
    ...mapActions(['availableLocation', 'selectedLocation']),
    ...mapActions('userInfo', {
      phoneAction: 'phone',
      emailAction: 'email',
    }),
    ...mapActions({
      dayOfWeekAction: 'dayOfWeek',
      zipCodeValueAction: 'zipCodeValue',
      cityTownAction: 'cityTown',
      textMsgCheckBoxAction: 'textMsgCheckBox',
    }),
    ...mapActions('bookingDetails', {
      newAppointmentSelectedAction: 'newAppointmentSelected',
    }),
    nextPage(page) {
      this.$emit('navigateTo', page);
    },
    async getAvailableLocation() {
      this.normalizeCityZip();
      this.loading = true;
      console.log('getAvailableLocation');
      console.log(this.testTypeId);
      console.log(this.zipCode);
      console.log(this.cityName);
      console.log(this.preferredDay);
      console.log(this.beginDate);
      console.log(this.beginDateEligibility);
      try {
        const response = await scApi.GetAvailableLocation(
          this.testTypeId,
          this.zipCode,
          this.cityName,
          this.preferredDay,
          this.beginDateEligibility,
        );
        if (response.length === 0) {
          console.log('There is no available location');
          this.isError = true;
          // eslint-disable-next-line prefer-template
          const msg = 'There is no availability for service type: ' + this.testTypeText;
          this.errorMessage = msg;
        } else {
          console.log(response);
          this.availableLocation({ value: response });
          this.selectedLocation({ value: response[0] });
          this.phoneAction({ value: this.phoneField });
          this.emailAction({ value: this.emailField });
          this.dayOfWeekAction({ value: this.preferredDay });
          this.zipCodeValueAction({ value: this.zipCode });
          this.cityTownAction({ value: this.cityName });
          this.textMsgCheckBoxAction({ value: this.textMsgCheck });
          console.log(this.$store.getters.availableLocation);
          this.$emit('navigateTo', 'SelectLocation');
        }
      } catch (error) {
        console.log(error);
        this.isError = true;
        this.errorMessage = error;
      } finally {
        console.log('Inside getAvailableLocation finally');
        this.loading = false;
      }
    },
    isValidEmail(value) {
      if (!value) {
        return this.Validation('Email address is required');
      }
      // eslint-disable-next-line no-useless-escape
      const regex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+")){2,}@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      if (!regex.test(value)) {
        return this.Validation('Invalid email address');
      }
      return true;
    },
    Validation(message) {
      this.valid = false;
      return message;
    },
    isValidPhone(value) {
      if (!value) {
        return this.Validation('Phone number is required');
      }
      if (value.length < 14) {
        return this.Validation('Invalid phone number');
      }
      return true;
    },
    formatPhoneNumber() {
      const x = this.phoneField.replace(/\D/g, '').match(/(\d{0,3})(\d{0,3})(\d{0,4})/);
      // eslint-disable-next-line prefer-template
      this.phoneField = !x[2] ? x[1] : '(' + x[1] + ') ' + x[2] + (x[3] ? '-' + x[3] : '');
    },
    isNumber(e) {
      if (e.keyCode >= 48 && e.keyCode <= 57) {
        // Number
        return true;
      }
      return e.preventDefault();
    },
    ValidZip(value) {
      const regex = /^[0-9]{5}(?:-[0-9]{4})?$/;
      return regex.test(value);
    },
    normalizeCityZip() {
      if (!this.ValidZip(this.zipCode) && this.cityName !== '') {
        this.zipCode = '';
      }

      if (this.ValidZip(this.zipCode)) {
        this.cityName = '';
      }
    },
    previousClick() {
      this.newAppointmentSelectedAction({ value: false });
      this.$emit('navigateTo', 'LandingPage');
    },
  },
  computed: {
    ...mapGetters('userInfo', [
      'dLNumber',
      'firstName',
      'lastName',
      'dateOfBirth',
      'email',
      'phone',
      'testTypeText',
      'testTypeId',
    ]),
    ...mapGetters(['cities']),
    ...mapGetters(['dayOfWeek', 'zipCodeValue', 'cityTown', 'textMsgCheckBox']),
    ...mapGetters(['beginDate']),
    cityRules() {
      return this.zipCode && this.ValidZip(this.zipCode) ? [] : [this.rules.required];
    },
    zipRules() {
      return this.cityName ? [] : [this.rules.required, this.rules.validZip];
    },
    beginDateEligibility() {
      return new Date(this.beginDate);
    },
  },
  mounted() {
    this.emailField = this.email;
    this.phoneField = this.phone;
    this.preferredDay = this.dayOfWeek;
    this.zipCode = this.zipCodeValue;
    this.cityName = this.cityTown;
    this.textMsgCheck = this.textMsgCheckBox;
  },
};
</script>

<style scoped>
.centerContainer {
  margin: auto;
  width: 95%;
}
</style>
